<app-option-bar [type]="moduleType" [details]="moduleDetails"></app-option-bar>
<div class="container-fluid testcase-wrapper">
  <div class="content-wrapper">
    <div class="inner-nav">
      <app-left-menu [details]="moduleDetails" [type]="moduleType"></app-left-menu>
    </div>

    <div class="inner-content collapsed">
      <div class="row">
        <div class="col-6 assoc-section">
          <div class="common-section">
            <div class="d-flex justify-content-between title">
              <h4 >Associate testcase(s)</h4>
              <span class="float-right"> 
                <button class="btn btn-sm text-white" style="background-color: #0288d1;" (click)="openFilter = !openFilter">
                  <i class="fas fa-filter clickable filter-instruction " ngbTooltip="Filter" id="filter" placement="left"></i>
                </button>
                  <a [routerLink]='"/testcase/new"' target="_blank"><button class="btn btn-sm ml-2 text-white" style="background-color: #0288d1;" ngbTooltip="Create Testcase">Create</button></a>
            </span>
              </div>
            <div class="mt-3" *ngIf="openFilter">
              <form [formGroup]="testCaseSearchForm" (ngSubmit)="pagination()" class="search-form">
                <div class="row filter-sec">
                  <div class="col-4">
                    <input type="text" id="keyword" class="form-control form-control-sm" placeholder="Search Keyword" formControlName="keyword">
                  </div>
                  <div class="col-4">
                    <ng-select class="custom-style" id="project-filter" [items]="myProjectsList" bindLabel="name" bindValue="id" placeholder="Select project" [searchable]="true" [multiple]="true" formControlName="projectIds">
                      <ng-template ng-option-tmp let-item="item">
                        <div title="{{item.name}}" class="text-truncate">{{item.name}}</div>
                      </ng-template>
                    </ng-select>
                  </div>
                  <div class="col-3">
                    <div style="display: flex;">
                      <div style="margin-left: auto;">
                        <button type="submit" class="btn search-btn btn-primary btn-sm" name="button" (click)="pagination()">Search</button>
                      </div>
                      <div>
                        <button class="btn btn-sm btn-warning ml-2" (click)="onClearFilter()">Clear</button>
                      </div>
                    </div>
                    <!-- <div>
                      <i class="fa fa-search clickable" style="padding-right: 5px; font-size: larger;" (click)="pagination()" ngbTooltip="Search"></i>
                      <i class="fas fa-times clickable cancle-icon" style="font-size: large;" (click)="onClearFilter()" ngbTooltip="Clear Filter"></i>
                    </div> -->
                  </div>

                  <div class="col-md-12 mt-2">
                    <div class="form-check form-check-inline">
                      <input class="form-check-input" type="checkbox" formControlName="certified" id="certified">
                      <label class="form-check-label" for="certified">Certified</label>
                    </div>
                    <div class="form-check form-check-inline">
                      <input class="form-check-input" type="checkbox" formControlName="nonFunctional" id="src-subflow">
                      <label class="form-check-label" for="src-subflow"> Non Functional</label>
                    </div>
                    <div class="form-check form-check-inline">
                      <input class="form-check-input" type="checkbox" formControlName="reviewed" id="reviewed">
                      <label class="form-check-label" for="reviewed">Reviewed</label>
                    </div>
                  </div>
                </div>
              </form>
            </div>

            <table class="table mt-3 endpointlist-table">
              <thead style="background-color: rgb(49, 49, 48);color: whitesmoke;">
                <tr>
                  <th class="col-endpoint">Testcase</th>
                  <th class="col-action text-right">Action</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngIf="testcaseList.length === 0">
                  <td colspan="2" class="text-center">No data found</td>
                </tr>
                <tr *ngFor="let testcase of testcaseList" [class.active]="isAssociated(testcase.id)">
                  <td class="col-endpoint" title="{{testcase.name}}">
                    <div class="endpoint-container">
                      <a class="mr-1" target="_blank" [routerLink]="['/testcase', testcase.id]"><i class="fas fa-link"></i></a>
                      <i class="fas fa-check-double text-success mr-1" ngbTooltip="Reviewed" *ngIf="testcase.reviewed"></i>
                      <i class="fas  fa-award text-success" ngbTooltip="Certified" *ngIf="testcase.certified"></i>
                      <span class="endpoint-text">{{testcase.name}}</span>
                    </div>
                  </td>
                  <td class="col-action text-right">
                    <i class="fas fa-plus-circle clickable text-primary" (click)="addToAssocTestCase(testcase)"
                      title="Add to testcase list" style="font-size: 16px;" *ngIf="!allowReviewedTestCases"></i>
                    <i class="fas fa-plus-circle clickable text-primary" [class.disabled-add-icon]="!testcase.reviewed"
                      (click)="testcase.reviewed ? addToAssocTestCase(testcase) : null"
                      title="{{testcase.reviewed ? 'Add to testcase list' : 'Add reviewed testcase to the list'}}"
                      style="font-size: 16px;" *ngIf="allowReviewedTestCases"></i>
                  </td>
                </tr>
              </tbody>
            </table>

          </div>

          <div class="pagination-sec mb-3">
            <div class="row">
              <div class="col">
                <b>Total results : </b>{{collectionSize}}
              </div>
              <div class="col-2 pr-0">
                <select class="form-control form-control-sm" (change)="onSizeChange()" [(ngModel)]="pageSize">
                  <option>15</option>
                  <option>25</option>
                  <option>50</option>
                  <option>100</option>
                </select>
              </div>
              <div class="col-md-auto ">
                <ngb-pagination class="d-flex justify-content-end" [collectionSize]="collectionSize" [maxSize]="5" [pageSize]="pageSize" [(page)]="page" [rotate]="true" (pageChange)="onPageChange($event)"></ngb-pagination>
              </div>
            </div>
          </div>

        </div>
        <div class="col-md-6 assoc-section">
          <div class="common-section">
            <div class="d-flex justify-content-between title"><h4 >Testsuite testcases</h4></div>
            <div class="extra-box mt-3" *ngIf="webAutomationTool !== 'PLAYWRIGHT'">
              <div class="row">
                <div class="col-md-6">
                  <b>Delay <small>(apply to all) </small></b>
                  <input type="number" class="form-control form-control-sm mr-1" name="Delay" [(ngModel)]="delayToAll" id="delay-all" min="0" placeholder="Delay" style="width:112px;display: inline-block;">
                  <input type="button" class="btn btn-primary btn-sm" id="changeDelayToAll" (click)="changeDelayToAll(delayToAll)" value="Apply" />
                </div>
                <div class="col-md-6 text-right">
                  <b>Retry <small>(apply to all) </small></b>
                  <input type="number" class="form-control form-control-sm mr-1" name="retryToALL" [(ngModel)]="retryToALL" id="retryToALL" max="3" min="0" placeholder="Retry" style="width:112px;display: inline-block;">
                  <input type="button" class="btn btn-primary btn-sm" id="changeRetryToAll" (click)="changeRetryToAll()" value="Apply" />
                </div>
              </div>
            </div>
            <div class="p-0 assoc-section" [class.assoc-selenium]="webAutomationTool !== 'PLAYWRIGHT'">
              <table class="assoc-table" [ngStyle]="{'margin-top': webAutomationTool === 'PLAYWRIGHT' ? '20px' : ''}" cdkDropList
                (cdkDropListDropped)="drop($event)">
                <thead style="background-color: rgb(49, 49, 48);color: whitesmoke;">
                  <tr>
                    <th class="assoc-col-name" style="text-align: left !important">Testcase</th>
                    <th class="assoc-col-time" *ngIf="webAutomationTool !== 'PLAYWRIGHT'">Delay in sec</th>
                    <th class="assoc-col-time" *ngIf="webAutomationTool !== 'PLAYWRIGHT'">Retry</th>
                    <th class="assoc-col-action">Action</th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngIf="selectedTestCases.length === 0">
                    <td colspan="4" class="text-center p-2"> <i class='fas fa-arrow-left text-primary mr-1'></i> Please select a
                      testcase from the list</td>
                  </tr>
                  <tr *ngFor="let testcase of selectedTestCases" cdkDrag>
              
                    <td class="assoc-col-name assoc-drag-handle" title="{{ testcase.name }}" style="text-align: left !important" cdkDragHandle>
                      <a class="mr-1" target="_blank" [routerLink]="['/testcase', testcase.testCaseId]"><i
                          class="fas fa-link"></i></a>
                      <i class="fas fa-check-double text-success mr-1" *ngIf="testcase.reviewed" ngbTooltip="Reviewed"></i>
                      <i class="fas fa-award text-success mr-1" *ngIf="testcase.certified" ngbTooltip="Certified"></i>
                      <span class="assoc-testcase-text">{{ testcase.name }}</span>
                    </td>
              
                    <td class="assoc-col-time" *ngIf="webAutomationTool !== 'PLAYWRIGHT'">
                      <input type="number" class="assoc-input" [(ngModel)]="testcase.delay" min="0" placeholder="Delay" />
                    </td>
              
                    <td class="assoc-col-time" *ngIf="webAutomationTool !== 'PLAYWRIGHT'">
                      <input type="number" class="assoc-input" [(ngModel)]="testcase.reTry" min="0" max="3" placeholder="Retry" />
                    </td>
              
                    <td class="assoc-col-action">
                      <i class="fas fa-ban assoc-clickable" [ngClass]="{ 'text-danger': !testcase.active }"
                        (click)="testcase.active = !testcase.active" title="Disable">
                      </i>
                      <i class="fas fa-trash-alt assoc-clickable text-danger clickable" (click)="removeAssocTestCase(testcase)"
                        title="Remove">
                      </i>
                    </td>
                  </tr>
                </tbody>
              </table>
              <div class="text-right mt-3 pb-2">
                <button type="button" class="btn relay-btn relay-createbtn" [ngClass]="isTSEdit ? 'update':'create'" (click)="onSubmit()">{{isTSEdit ? 'Update' : 'Create'}}</button>
                <button type="button" class="btn relay-btn cancel" [routerLink]="['/testsuite/',  testSuiteDetails.id]" *ngIf="testSuiteDetails?.id">Cancel</button>
                <button type="button" class="btn relay-btn cancel" [routerLink]="['/testsuite/']" [queryParams]="{page: 1, size: 15}" *ngIf="!testSuiteDetails?.id">Cancel</button>
              </div>

            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
